<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  
  <!-- SMALL loader for form content -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  
  @if (!showFormLoader) {
<div>
    
    <!-- Action buttons row (only visible when response exists) -->
    @if (dataServiceResponse != '') {
<div class="response-actions-row">
      <div class="copy-message-container">
        <span class="color-green">{{ copyMessage }}</span>
      </div>
      <div class="action-icons-container">
        <div class="action-icon copy-action" 
             (click)="copyClipboard()" 
             title="Copy Response">
          <i class="fa fa-copy"></i>
        </div>
        <div class="action-icon download-action" 
             (click)="downloadResponseAsFile()" 
             title="Download Response as JSON File">
          <i class="fa fa-download"></i>
        </div>
      </div>
    </div>
}
    
    <!-- Main content area with two columns -->
    <div class="content-container">
      
      <!-- Left column: Input parameters -->
      <div class="params-column">
        @for (item of inParams; track $index; let last = $last) {
<div class="param-row">
          <div class="param-label">
            <label>{{item.key}}:</label>
          </div>
          <div class="param-input">
            <input type="text" 
                   [(ngModel)]="item.value" 
                   class="form-control" /> 
            @if (last) {
<button class="call-api-button" 
                    
                    type="button" 
                    [disabled]="crudLoading"
                    (click)="test()">
              @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i> </span>
}Call API
            </button>
}
          </div>
        </div>
}
      </div>
      
      <!-- Right column: Response display -->
      <div class="response-column">
        
        <!-- Loading indicator -->
        @if (crudLoading && dataServiceResponse == '') {
<div class="loading-container">
          <i class="fa fa-spinner fa-spin" style="font-size: 2em; color: #337ab7;"></i>
          <p>Loading response...</p>
        </div>
}
        
        <!-- Warning message for large responses -->
        @if (isResponseTooLarge && dataServiceResponse != '') {
<div class="large-response-warning">
          <i class="fa fa-exclamation-triangle"></i>
          <div class="warning-content">
            <p>Response is too large to display completely. Please use the Download button to save the complete response.</p>
          </div>
        </div>
}
        
        <!-- Response display -->
        @if (dataServiceResponse != '' && !crudLoading) {
<div class="response-container">
          <pre class="json-view">{{ dataServiceResponse }}</pre>
        </div>
}
        
        <!-- Empty state message -->
        @if (dataServiceResponse == '' && !crudLoading) {
<div class="empty-state">
          <p>Please click on Call API to display the JSON response.</p>
        </div>
}
        
      </div>
      
    </div>
    
  </div>
}
  
</div>

